const TOKEN_KEY = 'ACH_ADMIN_TOKEN'
const USER_KEY = 'ACH_ADMIN_USER'
const MENU_KEY = 'ACH_ADMIN_MENUS'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token || '')
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}))
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  } catch (e) {
    return {}
  }
}

function normalizeMenus(rawMenus) {
  const menus = Array.isArray(rawMenus) ? rawMenus : []
  // 深拷贝，避免外部引用被我们调整
  const cloned = JSON.parse(JSON.stringify(menus))

  // 1) 先尝试从“业务管理”里摘出“订单管理”菜单
  let orderMenu = null
  const biz = cloned.find(m => m && (m.name === '业务管理' || m.path === '/biz'))
  if (biz && Array.isArray(biz.children) && biz.children.length) {
    const idx = biz.children.findIndex(c => c && (c.name === '订单管理' || c.path === '/biz/order'))
    if (idx >= 0) {
      orderMenu = biz.children.splice(idx, 1)[0]
    }
  }

  // 2) 若没在“业务管理”里找到，则看看是否已经是顶层“订单管理”菜单
  if (!orderMenu) {
    const topIdx = cloned.findIndex(m => m && (m.name === '订单管理' || m.path === '/biz/order') && (!m.children || !m.children.length))
    if (topIdx >= 0) {
      orderMenu = cloned.splice(topIdx, 1)[0]
    }
  }

  // 3) 确保存在一级目录“订单管理”，并把订单菜单挂到其下
  if (orderMenu) {
    let orderDir = cloned.find(m => m && (m.name === '订单管理' || m.path === '/order') && Array.isArray(m.children))
    if (!orderDir) {
      orderDir = { id: '0300', name: '订单管理', path: '/order', children: [] }
      // 尽量放到“业务管理”后面，保持菜单直观
      const bizIdx = cloned.findIndex(m => m && (m.name === '业务管理' || m.path === '/biz'))
      if (bizIdx >= 0) cloned.splice(bizIdx + 1, 0, orderDir)
      else cloned.push(orderDir)
    }

    if (!Array.isArray(orderDir.children)) orderDir.children = []
    const exists = orderDir.children.some(c => c && (c.path === orderMenu.path || c.name === orderMenu.name))
    if (!exists) orderDir.children.push(orderMenu)
  }

  return cloned
}

export function setMenus(menus) {
  localStorage.setItem(MENU_KEY, JSON.stringify(normalizeMenus(menus)))
}

export function getMenus() {
  try {
    const menus = JSON.parse(localStorage.getItem(MENU_KEY) || '[]')
    return normalizeMenus(menus)
  } catch (e) {
    return []
  }
}

export function clearAuth() {
  clearToken()
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(MENU_KEY)
}
